import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
// import Slider from './slider';
import Dmssg from "./components/DMssg";
import About from "./components/About";
import Startups from "./components/startups";
import Events from "../src/components/Event/Events.jsx";
import Achievements from "./components/Achievements";
import NotFound from "./components/Notfound";
import Landing from "./components/landing";
import TeamPage from "./components/TeamPage";
import Contact from "./components/contact";
import Facilities from "./components/Facilities";
import Mou from "../src/components/portfolio/Mou.jsx";
import Mentors from "./components/Mentors";
import DefenceStartup from "./components/portfolio/DefenceStartup.jsx";
import { motion, useScroll, useSpring } from "framer-motion";
import Career from "../src/components/Careers/Careers";
import Portfolio from "./components/portfolio/Portfolio.jsx";
import BiomanthanPage from "./components/BioManthan.jsx";
import SchoolOfEntrepreneurship from "./components/SchoolOfEntrepreneurship";


function App() {
  const topRef = useRef(null);
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });
  return (
    <Router basename={process.env.NODE_ENV === "development" ? "/" : "/tbif"}>
      <div ref={topRef}>
        <Navbar />
        <motion.div
          className="progress-bar shadow-lg shadow-pink-700"
          style={{ scaleX }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/tbif" element={<Landing />} />
          <Route path="/*" element={<Landing />} />
          <Route path="/dmssg" element={<Dmssg />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/startups" element={<Startups />} />
          <Route path="/events" element={<Events />} />
          <Route path="/mous" element={<Mou />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/facilities" element={<Facilities />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/career" element={<Career />} />
          <Route path="/achievements" element={<Achievements />} />
          <Route path="/defence" element={<DefenceStartup />} />
          <Route path="/mentors" element={<Mentors />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/BioMANTHAN" element={<BiomanthanPage/>}/>
          <Route path="/SchoolOfEntrepreneurship" element={<SchoolOfEntrepreneurship />}
                  />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
